import type { PlainDate, PlainDateString } from "@sa-nu/shared-utils/date";
import { genPlainDateList, toPlainDateString } from "@sa-nu/shared-utils/date";

/**
 * CI(firstNight)〜CO前夜(lastNight)間の price 合計を確定金額として算出する。
 * CO 未確定 (lastNight=null)、または確定金額利用不可の場合は算出できないため null を返す。
 */
export function deriveConfirmedPrice(
  canUseGuaranteedPriceAsConfirmedAmount: boolean,
  nightPrices: Record<PlainDateString, number>,
  firstNight: PlainDate | null,
  lastNight: PlainDate | null,
): number | null {
  if (!canUseGuaranteedPriceAsConfirmedAmount) return null;
  if (firstNight === null || lastNight === null) return null;

  return genPlainDateList(firstNight, lastNight).reduce(
    (total, night) => total + (nightPrices[toPlainDateString(night)] ?? 0),
    0,
  );
}
